import api from "../../../services/api";
import { buildRelatorioWithPayload } from "./model";

const postRelatorio = async (url, filterData, signal) => {
  const response = await api.post(url, buildRelatorioWithPayload(filterData), {
    signal,
  });
  return response?.data;
};

export const relatorioWithController = {
  getConsolidado: (filterData, signal) =>
    postRelatorio("/find/reincidencia/consolidado", filterData, signal),
  getMotivos: (filterData, signal) =>
    postRelatorio("/find/reincidencia/motivos", filterData, signal),
  getRegional: (filterData, signal) =>
    postRelatorio("/find/reincidencia/regional", filterData, signal),
  getTecnicos: (filterData, signal) =>
    postRelatorio("/find/reincidencia/tecnicos", filterData, signal),
  getAtendimento: (filterData, signal) =>
    postRelatorio("/find/reincidencia/atendimento", filterData, signal),
  getSetor: (filterData, signal) =>
    postRelatorio("/find/reincidencia/setor", filterData, signal),
  getFiltros: (signal) =>
    api.get("/find/reincidencia/filtros", { signal }),
};
